export const SPECIALITIES_OPTIONS = [
  'اوسینت',
  'خبر و خبرنگاری',
  'تولیدات تصویری',
  'زیست دیجیتال بانوان',
  'شبکه‌های اجتماعی',
  'سواد فضای مجازی',
  'شتاب',
  'هوش مصنوعی',
  'فکت چک',
  'شبکه سازی',
  'پادکست',
  'دین و رسانه',
  'جریان شناسی مقاومت',
]

// آرمان ما ۲
export const PUBLIC_CHANNELS_INVITE_LINKS = ['_CO3meNM7H3DYkx1']

export const MAP_SPECIALITIES_TO_CHANNEL_INVITATION_LINK: Record<
  string,
  string
> = {
  اوسینت: 'JVFhJbwSiZXt7kkt',
  'خبر و خبرنگاری': 'wm4u2O6Y7V5MpdP-',
  'تولیدات تصویری': 'l2dleOzQ5kYVWTMf',
  'زیست دیجیتال بانوان': 'BrDWN0RiGDo1nDRr',
  'شبکه‌های اجتماعی': 'k59V10DR6TFCHlPT',
  'سواد فضای مجازی': 'E5d9Tx7VEUucM6Le',
  شتاب: '_oq7RnLp4A9svOZ8',
  'هوش مصنوعی': 'FAI27MckN_iXmEFP',
  'فکت چک': '8BfZG2OdkTEGvC31',
  'شبکه سازی': 'C-Z4Sgo6Nw9ojevO',
  پادکست: '_aZuN1ZNX0-OIV3U',
  'دین و رسانه': '0J8FuRUMjTOXsfwr',
  'جریان شناسی مقاومت': 'F89naQYRYqJCfx9W',
}
